export default __webpack_public_path__ + "static/media/create_proposal_gray.c3efd2ee.svg";